import React from 'react';
import { LimitedEditionBanner } from '../components/LimitedEditionBanner';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { FailedAttempts } from '../components/FailedAttempts';
import { MechanismSection } from '../components/MechanismSection';
import { WhatYouGet } from '../components/WhatYouGet';
import { WhoIsItFor } from '../components/WhoIsItFor';
import { HowItWorks } from '../components/HowItWorks';
import { ProofSection } from '../components/ProofSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { FAQSection } from '../components/FAQSection';
import { OfferSection } from '../components/OfferSection';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <main className="min-h-screen bg-cream selection:bg-leaf selection:text-white overflow-x-hidden" data-id="element-229">
      <LimitedEditionBanner data-id="element-230" />
      <HeroSection data-id="element-231" />
      <ProblemSection data-id="element-232" />
      <FailedAttempts data-id="element-233" />
      <MechanismSection data-id="element-234" />
      <WhatYouGet data-id="element-235" />
      <WhoIsItFor data-id="element-236" />
      <HowItWorks data-id="element-237" />
      <ProofSection data-id="element-238" />
      <TestimonialsSection data-id="element-239" />
      <FAQSection data-id="element-240" />
      <OfferSection data-id="element-241" />
      <Footer data-id="element-242" />
    </main>;
}